import { http } from './http';

function camelToSnake(str) {
    return String(str).replace(/[A-Z]/g, (m) => '_' + m.toLowerCase());
}

function normalizeDateTime(val) {
    if (!val) return val;
    const s = String(val).trim();
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)) return s;
    const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})$/);
    if (m) {
        const [, dd, mm, yyyy, HH, MM] = m;
        return `${yyyy}-${mm}-${dd}T${HH}:${MM}:00`;
    }
    const m2 = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m2) {
        const [, dd, mm, yyyy] = m2;
        return `${yyyy}-${mm}-${dd}T00:00:00`;
    }
    return s;
}

function normalizePayload(payload = {}) {
    const out = {};
    for (const [key, value] of Object.entries(payload)) {
        if (value === undefined) continue;
        if (key === 'dateTime') {
            out['date_time'] = normalizeDateTime(value);
            continue;
        }
        if (key === 'idx') {
            const n = typeof value === 'string' ? value.trim() : value;
            const parsed = Number(n);
            out['idx'] = Number.isFinite(parsed) ? parsed : value;
            continue;
        }
        out[camelToSnake(key)] = value;
    }
    return out;
}

export async function listBorderRegimeViolations(params = {}) {
    const { data } = await http.get('book/border-violations/', { params });
    return data;
}

export async function getBorderRegimeViolation(id) {
    const { data } = await http.get(`book/border-violations/${id}/`);
    return data;
}

export async function createBorderRegimeViolation(payload) {
    const norm = normalizePayload(payload);
    const { data } = await http.post('book/border-violations/', norm);
    return data;
}

export async function updateBorderRegimeViolation(id, payload) {
    const norm = normalizePayload(payload);
    const { data } = await http.patch(`book/border-violations/${id}/`, norm);
    return data;
}

export async function deleteBorderRegimeViolation(id) {
    const { data } = await http.delete(`book/border-violations/${id}/`);
    return data;
}
